import React, { Component } from "react";
import {FaTwitter ,FaInstagram ,FaFacebookF , FaLinkedinIn, FaYoutube } from "react-icons/fa";
import { FiX , FiMenu} from "react-icons/fi";
import Scrollspy from 'react-scrollspy'

const SocialShare = [
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/share/15SnoHLaBP/?mibextid=wwXIfr'},
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/in/dennis-isiakpona?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app'},
    {Social: <FaYoutube />, link: 'https://youtube.com/@dennisogeisiakpona919?si=b3SuwX__wnDRCj1J'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/thea.q.u.i.l.a?igsh=MWx4bHlkbThlNXlteg%3D%3D&utm_source=qr'},
    {Social: <FaTwitter /> , link: 'https://x.com/_theaquila_?s=21'}
]
class HeaderThree extends Component{
    constructor(props) {
        super(props);
        this.menuTrigger = this.menuTrigger.bind(this);
        this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);
        this.stickyHeader = this.stickyHeader.bind(this);

       //  this.subMetuTrigger = this.subMetuTrigger.bind(this);
        window.addEventListener('load', function() {
            console.log('All assets are loaded');
        })
        
    }
    menuTrigger() {
        document.querySelector('.header-wrapper').classList.toggle('menu-open')
    }
    
    CLoseMenuTrigger() {
        document.querySelector('.header-wrapper').classList.remove('menu-open')
    }

    stickyHeader () {}

    render(){

        window.addEventListener('scroll', function() {
            var value = window.scrollY;
            if (value > 100) {
                document.querySelector('.header--fixed').classList.add('sticky')
            }else{
                document.querySelector('.header--fixed').classList.remove('sticky')
            }
        });

        var elements = document.querySelectorAll('.has-droupdown > a');
        for(var i in elements) {
            if(elements.hasOwnProperty(i)) {
                elements[i].onclick = function() {
                    this.parentElement.querySelector('.submenu').classList.toggle("active");
                    this.classList.toggle("open");
                }
            }
        }
        const { logo, color='default-color' } = this.props;
        let logoUrl;
        if(logo === 'light'){
            logoUrl = <img src="/assets/images/logo/logo-white.png" height="50rem" alt="Coach DOI" />;
        }else if(logo === 'dark'){
            logoUrl = <img src="/assets/images/logo/logo-black.png" height="50rem" alt="Coach DOI" />;
        }else if(logo === 'symbol-dark'){
            logoUrl = <img src="/assets/images/logo/logo-black.png" height="50rem" alt="Coach DOI" />;
        }else if(logo === 'symbol-light'){
            logoUrl = <img src="/assets/images/logo/logo-white.png" height="50rem" alt="Coach DOI" />;
        }else{
            logoUrl = <img src="/assets/images/logo/logo-black.png" height="50rem" alt="Coach DOI" />;
        }
        
        return(
            <header className={`header-area header-style-two header--fixed ${color}`}>
                <div className="header-wrapper">
                    <div className="header-left d-flex align-items-center">
                        <div className="logo">
                            <a href={this.props.homeLink}>
                                {logoUrl}
                            </a>
                        </div>
                        <nav className="mainmenunav d-lg-block ml--50">
                            <Scrollspy className="mainmenu" items={['home','about','courses','service','portfolio','contact']} currentClassName="is-current" offset={-200}>
                                <ul className="mainmenu">
                                    <li><a href="/">Home</a></li>
                                    <li><a href="/about">About</a></li>
                                    <li className="has-droupdown"><a href="#">&nbsp;&nbsp;&nbsp;&nbsp; Courses</a>
                                        <ul className="submenu">
                                            <li><a href="/resilient-professional">The Resilient Professional</a></li>
                                            <li><a href="/exploiting-your-value">Decoupling and Exploiting Your Value</a></li>
                                            <li><a href="/career-trajectory">Career Trajectory</a></li>
                                            <li><a href="/value-driven-leader">The Value-Driven Leader</a></li>
                                        </ul>
                                    </li>
                                    <li className="has-droupdown"><a href="#">&nbsp;&nbsp;&nbsp;&nbsp; Coaching</a>
                                        <ul className="submenu">
                                            <li><a href="/pmmp">Project Management Mentorship Program</a></li>
                                            <li><a href="/change-leadership">Change Leadership</a></li>
                                            <li><a href="/business-transformation-catalyst">Business Transformation Catalyst</a></li>
                                        </ul>
                                    </li>
                                    <li className="has-droupdown"><a href="#">&nbsp;&nbsp;&nbsp;&nbsp; Portfolio</a>
                                        <ul className="submenu">
                                            <li><a href="/stumbling-towards-clarity">Stumbling Towards Clarity</a></li>
                                        </ul>
                                    </li>
                                    <li><a href="https://pathfinderxconsulting.com" target="_blank">PathFinderX</a></li>
                                    <li><a href="/contact">Contact</a></li>
                                </ul>
                            </Scrollspy>
                        </nav>
                    </div>
                    <div className="header-right">
                        <div className="social-share-inner">
                            <ul className="social-share social-style--2 color-black d-flex justify-content-start liststyle">
                                {SocialShare.map((val , i) => (
                                    <li key={i}><a href={`${val.link}`} target="_blank">{val.Social}</a></li>
                                ))}
                            </ul>
                        </div>
                        {/* <div className="header-btn">
                            <a className="rn-btn" href="/#contact">
                                <span>get started</span>
                            </a>
                        </div> */}
                        {/* Start Humberger Menu  */}
                        <div className="humberger-menu d-block d-lg-none pl--20">
                            <span onClick={this.menuTrigger} className="menutrigger text-white"><FiMenu /></span>
                        </div>
                        {/* End Humberger Menu  */}
                        <div className="close-menu d-block d-lg-none">
                            <span onClick={this.CLoseMenuTrigger} className="closeTrigger"><FiX /></span>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}
export default HeaderThree;